module.exports = __webpack_public_path__ + "stickermule-2-4032f96a8cbd4889282c9664e0608c90.webp";